import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';

export function Clients() {
  const { language } = useLanguage();

  const text = {
    fr: {
      title: 'Gestion des Clients',
      subtitle: 'Gérez votre base de clients',
    },
    en: {
      title: 'Client Management',
      subtitle: 'Manage your client base',
    }
  };

  const currentText = text[language as keyof typeof text];

  return (
    <Box sx={{ p: 3, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Typography variant="h4" gutterBottom>
        {currentText.title}
      </Typography>
      <Typography color="text.secondary">
        {currentText.subtitle}
      </Typography>
    </Box>
  );
}
